/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Einstellungen für Ihre Fahrt`
};

const en_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Your trip parameters`
};

const es_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Parámetros de tu trayecto`
};

const fr_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Paramètres de votre trajet`
};

const it_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Impostazioni per il percorso`
};

const nl_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Instellingen voor uw reis`
};

const pt_itinerary__options__title = /** @type {(inputs: {}) => string} */ () => {
	return `Definições do seu trajeto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__title", locale)
	if (locale === "de") return de_itinerary__options__title(inputs)
	if (locale === "en") return en_itinerary__options__title(inputs)
	if (locale === "es") return es_itinerary__options__title(inputs)
	if (locale === "fr") return fr_itinerary__options__title(inputs)
	if (locale === "it") return it_itinerary__options__title(inputs)
	if (locale === "nl") return nl_itinerary__options__title(inputs)
	return pt_itinerary__options__title(inputs)
};